export type EventTypeOption = {
  automationId?: string;
  description: string;
  icon: string;
  id: number;
  isEnabled: boolean;
  sendTo?: string;
  title: string;
  whenToSendDescription: string | null;
};

export const eventTypeOptions: EventTypeOption[] = [
  {
    id: 1,
    title: 'Post purchase',
    description:
      'Use this automation to send a post-purchase email to thank customers and offer them a special discount on their next order.',
    icon: 'post-purchase',
    isEnabled: true,
    automationId: 'trigger-post-purchase',
    whenToSendDescription: 'How long after a purchase should this campaign be sent?',
    sendTo: 'All post purchase customers',
  },
  {
    id: 2,
    title: 'New customer',
    description:
      'Welcome new customers with a first purchase email and other incentives as a way of saying thanks for their first order.',
    icon: 'new-customer',
    isEnabled: true,
    automationId: 'trigger-new-customer',
    whenToSendDescription: 'How long after a customer makes their first purchase should this campaign be sent?',
    sendTo: 'All new customers',
  },
  {
    id: 4,
    title: 'Upcoming birthday',
    description:
      'Send a birthday email that includes a special offer to your customers to celebrate their special upcoming day.',
    icon: 'upcoming-birthday',
    isEnabled: true,
    automationId: 'trigger-birthday',
    whenToSendDescription: 'How many days prior to the customers birthday do you want to send this campaign?',
    sendTo: 'All customers with an upcoming birthday',
  },
  {
    id: 5,
    title: 'After loyalty enrollment',
    description:
      'Thank customers for joining your loyalty program with a welcome email, highlighting the exclusive perks they can now enjoy.',
    icon: 'hand-shake-heart',
    isEnabled: true,
    automationId: 'trigger-loyalty-enrollment',
    whenToSendDescription: 'How long after a customer enrolls in your loyalty program should this campaign be sent?',
    sendTo: 'All loyalty program customers',
  },
  {
    id: 7,
    title: 'Entered segment',
    description: 'Create targeted campaigns based on your segments and reach new customers added to those segments',
    icon: 'pie-chart',
    isEnabled: true,
    automationId: 'trigger-entered-segment',
    whenToSendDescription: null,
    sendTo: 'All customers who enter the selected segments',
  },
  {
    id: 3,
    title: 'Abandoned cart',
    description:
      'Encourage customers to complete their purchase with this Abandoned Cart automation and 10% off coupon.',
    icon: 'shopping-cart-removed',
    isEnabled: true,
    automationId: 'trigger-abandoned-cart',
    whenToSendDescription: 'How long after a cart has been abandoned do you want to send this campaign?',
    sendTo: 'All abandoned cart customers',
  },
];
